import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'grabbill-client-sms-stat',
  templateUrl: './sms-stat.component.html',
  styleUrls: ['./sms-stat.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsStatComponent {
  @Input()
  totalSms!: number;

  @Input()
  smsSent!: number;

  @Input()
  smsDelivered: number = 0;

  @Input()
  smsFailed: number = 0;

  @Input()
  smsError!: number;

  @Input()
  totalCreditUsed!: number;

  // Which stat box's filter is currently applied by the parent (or null/
  // undefined for none) - drives the `.active` highlight below.
  @Input()
  activeFilter: string | null = null;

  // True when the Record Status dropdown filter (owned by the parent) is
  // narrowing the table - so the Total box only claims "showing everything"
  // when that's actually true, not just when no stat box happens to be
  // clicked.
  @Input()
  hasOtherFiltersActive: boolean = false;

  // Emits the clicked box's key ('sent'/'error'), or null for the Total
  // box. Toggle/switch logic lives in the parent. Total Credit Used isn't
  // a boolean-flag category like the others (it's a sum), so it has no
  // click binding at all - nothing to emit for it.
  @Output()
  filterChange = new EventEmitter<string | null>();
}
